$(document).ready(function() {
  $('.notify_failure').hide();
  $('.notify_success').hide();
  
  function validateEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
  $('#MailNotify').click(function(event) {
     event.preventDefault();

    var email = $('#notify_emails').val();
    var productName = $('#product-name').val();
    var productUrl = $('#product-url').val();
    var productId = $('#product-id').val();
    var productPrice = $("#product-price").val();
    var productImage = $("#product-image").val();
    var variantId = $("#variant-id").val();
    var variantSKU = $("#variant-sku").val();
    var storeLanguage = $("#store-language").val();
    var customerId = $("#customerid").val();
    var customerName = $("#customername").val();


    console.log('Email to be posted:-', email);
    console.log('Product Name:-', productName);
    console.log('Product Url:-', productUrl);
    console.log('product Id:-', productId);
    console.log('product Price:-', productPrice);
    console.log('product Image:-', productImage);
    console.log('Variant Id:-', variantId);
    console.log('Variant Sku:-', variantSKU);
    console.log('storeLanguage:-', storeLanguage);
    console.log('customer Id:-', customerId);
    console.log('customer Name:-', customerName);

    
    // Validate the email if necessary

      if (!validateEmail(email)) {
        alert("Please enter a valid email address.");
        return false;
      }
    
    // Example: post the email using AJAX
    $.ajax({
      url: 'https://ps16.store-and-supply.com/shopify_apps/ek/back_to_stock/import-script/email_alert.php',
      type: 'POST',
      data: { email: email, productName: productName, productUrl: productUrl, productId: productId, productPrice: productPrice, productImage: productImage, variantId: variantId, 
               variantSKU: variantSKU, storeLanguage: storeLanguage, customerId: customerId, customerName: customerName }, // Removed the trailing comma
      success: function(response){
        if (response === "Customer data registered") {
          $('.notify_success').show();
          $('.notify_failure').hide();
        } else if (response === "Already registered this mail") {
          $('.notify_failure').show();
          $('.notify_success').hide();
        } else {
          console.error('Unexpected response:', response);
        }
      },
      
      error: function(xhr, status, error) {
        console.error('Error posting email:', error);
        $('.notify_failure').show();
        $('.notify_success').hide();
      }
    });
  });
});